import { useEffect, useState } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import { FaAccusoft, FaUpload } from "react-icons/fa";
import { IoCreateSharp } from "react-icons/io5";
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { useFirebase } from 'react-redux-firebase';
import moment from "moment";
import CustomizedSnackbars from '../Feedback';
import QualificationsTable from './Admission/Tables/QualificationsTable';
import { createAdminAction } from '../../Firebase/actions/createAdminAction';
import * as EmailValidator from 'email-validator';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const AdminSignUp = ({ createAdminAction, createAdminSuccess, createAdminError, resetSuccess, adminmails, resetError,auth }) => {
    const [title, setTitle] = useState('');
    const [ forenames, setForeNames ] = useState('');
    const [ surname, setSurname ] = useState('');
    const [ dob, setDob ] = useState('');
    const [ gender, setGender ] = useState('');
    const [ idNumber, setIdNumber ] = useState('');
    const [ email, setEmail ] = useState('');
    const [ phoneNumber, setPhoneNumber ] = useState('');
    const [ password1, setPassword1 ] = useState('');
    const [ password2, setPassword2 ] = useState('');
    const [ pwdToogle, setPwdToogle] = useState('Show Password');
    const [ signedUp, setSignedUp ] =useState(null);

    const [ qualifications, setQualifications ] = useState([]);
    const [ qualification, setQualification ] = useState('');
    const [ qualificationError, setQualificationError ] = useState(false);

    const [adminLevel, setAdminLevel ] = useState('');
    const [ error, setError] = useState(null);

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const firebase = useFirebase();


    const tooglePwdVisibility = () => {
        if(pwdToogle === 'Show Password') {     
            document.getElementById('passwordField1').setAttribute("type", "text");    
            document.getElementById('passwordField2').setAttribute("type", "text");    
            setPwdToogle('Hide Password');
        }
        if(pwdToogle === 'Hide Password') { 
            document.getElementById('passwordField1').setAttribute("type", "password");    
            document.getElementById('passwordField2').setAttribute("type", "password");           
            setPwdToogle('Show Password');
        } 
    }

    const addQualification = () => {
        if(qualification === '') {
            setQualificationError(true);
            return;
        } else {
            setQualificationError(false);
            setQualifications([...qualifications, qualification]);
            setQualification('');
        }
    }
    
                    

    const handleSubmit = (e) => {
        e.preventDefault();

        if(title !== '' || forenames  !== '' || surname  !== '' || dob  !== '' || gender  !== '' || idNumber  !== '' || email  !== '' || phoneNumber  !== '' || adminLevel  !== '' || password1 !== '' || password2 !== '') {
            setError(null);
            
            if(!EmailValidator.validate(email)){
                setError('Please provide a valid email.');
            } else {
                setError(null);
                if(password1.length < 6) {
                    setError('Password choice should be at least 6 characters.');   
                } else {
                    if( password1 !== password2 ) {
                        setError('Passwords do not match.');
                    } else { 
                        let admin
                        if (adminmails) {
                            admin = adminmails.filter((item) => {
                                return item.email === email && item.adminLevel === adminLevel
                            });          
                            
                            if(admin.length === 0 ){
                                setError('No matching admin records...')
                            } else {
                                //doAction(student);'
                                setError(null);
                                document.getElementById('Btn').classList.add('is-loading');
                                //console.log(admin)
                                firebase.auth().createUserWithEmailAndPassword(email, password1)
                                .then((userCredential) => {
                                    // Signed in 
                                    var userId = userCredential.user.uid;
                                    // ...
                                    let data = {
                                        title,
                                        forenames,
                                        surname,
                                        dob,
                                        gender,
                                        idNumber,
                                        email,
                                        phoneNumber,
                                        adminLevel,
                                        qualifications,
                                        userId
                                    }
                                    //console.log(admin);

                                    createAdminAction(data);
                                })
                                .catch((error) => {
                                    document.getElementById('Btn').classList.remove('is-loading');
                                    setError(error.message);
                                });
                            }
                            
                        }
                    }
                }
            }
        
        } else {
            setError('Please ensure that all field are filled.');
        }        
    }

    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });

        if(createAdminSuccess) {
            document.getElementById('Btn').classList.remove('is-loading');
            //reset form
            setForeNames('');
            setSurname('');
            setDob('');     
            setIdNumber('');
            setEmail('');
            setPhoneNumber('');
            setQualifications([]);



            //on success
            setFeedbackText('Successfully Sign Up.');
            setSeverity('success');
            setOpenFeedback(true);

            
            resetSuccess();
            setSignedUp(true);

        }

        if(createAdminError) {
            document.getElementById('Btn').classList.remove('is-loading');
            // //on error
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);


            resetError();
        }

        var defaultDate= new Date('January 1, 2010');

        var datepicker = document.querySelectorAll('.datepicker');
        let selectedDate;
        M.Datepicker.init(datepicker, {
            yearRange: [1980,2010],
            showMonthAfterYear: true,
            defaultDate,
            setDefaultDate: true,
            format: 'dd mmmm yyyy',
            onSelect: (date) => {
                selectedDate = moment(date).format('DD MMMM YYYY');
            },
            onClose: () => {
                setDob(selectedDate);
            }
        });

    }, [createAdminSuccess, createAdminError, resetSuccess, resetError]);

    return (
        <div className="container box">
            <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic is Registered with the Ministry of Higher And Tertiary Education, Science and Technology Development."
                />
                <title>Admin Sign Up</title>
            </Helmet>
            <div className="row ">
                <div className="col s12 m10 l10 offfset-m1 offset-l1">
                    <h5 className="title has-text-weight-bold mt-6 mb-2 grey-text text-darken-3">Admin Sign Up</h5>
                    <div className="divider mb-5"></div>

                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <h5 className="is-size-5 has-text-weight-semibold mt-6 mb-4 grey-text text-darken-3">Personal Information</h5>
                            <div className="col s12">
                                <div className="row">
                                    <div className="input-field col s4 m2">
                                        <select onChange={(e) => setTitle(e.target.value)} value={title} >
                                            <option value="" disabled >Select</option>
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Miss">Miss</option>
                                        </select>
                                        <label>Title</label>
                                    </div>
                                    <div className="input-field col s8 m5 l4">
                                        <input id="lastName" type="text" onChange={(e) => setSurname(e.target.value)} value={surname} required />
                                        <label htmlFor="lastName" className="active">Last Name</label>
                                    </div>
                                    <div className="input-field col s12 m5 l6">
                                        <input id="firstName" type="text" onChange={(e) => setForeNames(e.target.value)} value={forenames} required />
                                        <label htmlFor="firstName" className="active">Forename(s)</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="input-field col s12 m4">
                                        <input id="dateOfBirth" type="text" className="datepicker" defaultValue={dob} />
                                        <label htmlFor="dateOfBirth" className="active">Date Of Birth:</label>
                                    </div>
                                    <div className="input-field col s4">
                                        <select onChange={(e) => setGender(e.target.value)} value={gender}  >
                                            <option value="" disabled>Select</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                        </select>
                                        <label>Gender</label>
                                    </div>
                            
                                </div>
                                <div className="row">
                                    <div className="input-field col s12 m6">
                                        <input id="idNumber" type="text" onChange={(e) => setIdNumber(e.target.value)} value={idNumber} />
                                        <label htmlFor="idNumber" className="active">National ID No. (e.g 123456A78)</label>
                                    </div>
                                    <div className="input-field col s12 m5">
                                        <input id="phoneNumber" type="text" onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber} required />
                                        <label htmlFor="phoneNumber" className="active">Phone Number</label>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                        <h5 className="is-size-5 has-text-weight-semibold mt-6 mb-4 grey-text text-darken-3">Qualifications: </h5>
                        <div className="row">
                            <div className="input-field col s12 m5">
                                <input id="qualification" type="text" onChange={(e) => setQualification(e.target.value)} value={qualification} />
                                <label htmlFor="qualification" className="active">(e.g Hon. Degree in Marketing (UZ) )</label>
                            </div>
                        </div>
                        {
                            qualificationError && <p className="mt-1 main-color-text">Please fill all the fields.</p>
                        }
                        <div className="control">
                            <div 
                                className="button is-small is-info mt-2"
                                onClick={addQualification}
                            >
                                <span className="icon">
                                    <FaUpload color="white"/>
                                </span>
                                <span className="white-text">Add Qualification</span>
                            </div>
                        </div>
                        {
                            qualifications.length !== 0 &&  <QualificationsTable qualifications={qualifications} setQualifications={setQualifications}/>
                        }


                        <h5 className="is-size-5 has-text-weight-semibold mt-6 mb-4 grey-text text-darken-3">Admin Level: </h5>
                        <div className="row">
                            <div className="input-field col s12 m4 ">
                                <select onChange={(e) => setAdminLevel(e.target.value)} value={adminLevel}  >
                                    <option value="" disabled>Select</option>
                                    <option value="Main">Main</option>
                                    <option value="Bursary">Bursary</option>
                                    <option value="Teacher">Teacher</option>
                                </select>
                                <label>Select Level</label>
                            </div>
                        </div>
                        
                        <h5 className="is-size-5 has-text-weight-semibold mt-6 mb-4 grey-text text-darken-3">Credentials: </h5>
                        <div className="row">
                            <div className="input-field col s12 m6">
                                <input id="email" type="email" className="validate" onChange={(e) => setEmail(e.target.value)} value={email} required />
                                <label htmlFor="email" className="active">Email</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field col s12 m6">
                                <input id="passwordField1"  type="password" onChange={(e) => setPassword1(e.target.value)} value={password1} required />
                                <label htmlFor="passwordField1" className="active">Password</label> 
                            </div>
                            <div className="input-field col s12 m6">
                                <input id="passwordField2" type="password" onChange={(e) => setPassword2(e.target.value)} value={password2} required />
                                <label htmlFor="passwordField2" className="active">Password</label>
                            </div>
                        </div>
                        {
                            pwdToogle === 'Show Password' ? (
                                    <div 
                                        className="left-align small-text has-text-weight-light mt-3 cursor-pointer"
                                        onClick={tooglePwdVisibility}
                                    >
                                        Show Password
                                    </div>
                                ) : (
                                    <div 
                                        className="left-align small-text has-text-weight-light mt-3 cursor-pointer"
                                        onClick={tooglePwdVisibility}
                                    >
                                        Hide Password
                                    </div>
                                )
                            }
                        {
                            error && <p className="red-text text-darken-3 mt-4">{error}</p>
                        }
                        <div className="control">
                            <button className="button is-success mt-5" id="Btn">
                                <span className="icon">
                                    <IoCreateSharp color="white"/>
                                </span>
                                <span className="white-text">Create Admin Account</span>
                            </button>
                            {
                                signedUp && (
                                    <Link className="button is-info mt-5 ml-4" to="/admin">
                                        <span className="icon">
                                            <FaAccusoft color="white"/>
                                        </span>
                                        <span className="white-text">Log In Now</span>
                                    </Link>
                                )
                            }
                        </div>
                        
                    </form>
                </div>
            </div>
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </div>
    );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        auth: state.firebase.auth,
        adminmails: state.firestore.ordered.adminmails,
        createAdminSuccess: state.createAdmin.createAdminSuccess,
        createAdminError: state.createAdmin.createAdminError  
    }
    
}

const mapDispatchToProps = (dispatch) => {
    return {
        createAdminAction: (admin) => dispatch(createAdminAction(admin)),
        resetSuccess: () => dispatch({ type: "CREATE_ADMIN", success: false }),
        resetError: () => dispatch({ type: "CREATE_ADMIN_ERR", success: false })
    };
};
  

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "adminmails", 
            },
    ])
)(AdminSignUp);

